















import { Component, Prop, Vue } from "vue-property-decorator"

@Component
export default class Section extends Vue {
	@Prop() private header!: string;
	@Prop() private content!: string;
}
